export default "__VITE_ASSET__DoKlKVfa__"